enum RoutePath {
  APP_DASHBOARD = 'APP_DASHBOARD',
  APP_EXTERNAL_DASHBOARD = 'APP_EXTERNAL_DASHBOARD',
  BACK = 'BACK',
  EDITOR_COMPLETE_APP_SETUP = 'EDITOR_COMPLETE_APP_SETUP',
  WIX_OFFERING = 'WIX_OFFERING',
  APP_PAGE = 'APP_PAGE',
}
interface AppDashboardRoutePayload {
  appId: string;
}
interface AppExternalDashboardRoutePayload {
  appId: string;
  url: string;
}
interface EditorCompleteAppSetupRoutePayload {
  appId: string;
}
interface WixOfferingRoutePayload {
  appId: string;
}

interface AppPageRoutePayload {
  appId: string;
}

interface RoutePayloadMap {
  [RoutePath.APP_DASHBOARD]: AppDashboardRoutePayload;
  [RoutePath.APP_EXTERNAL_DASHBOARD]: AppExternalDashboardRoutePayload;
  [RoutePath.BACK]: undefined;
  [RoutePath.EDITOR_COMPLETE_APP_SETUP]: EditorCompleteAppSetupRoutePayload;
  [RoutePath.WIX_OFFERING]: WixOfferingRoutePayload;
  [RoutePath.APP_PAGE]: AppPageRoutePayload;
}

type SomeRoute<T extends RoutePath> = {
  path: T;
  payload: RoutePayloadMap[T];
};

type Route =
  | SomeRoute<RoutePath.APP_DASHBOARD>
  | SomeRoute<RoutePath.APP_EXTERNAL_DASHBOARD>
  | SomeRoute<RoutePath.BACK>
  | SomeRoute<RoutePath.EDITOR_COMPLETE_APP_SETUP>
  | SomeRoute<RoutePath.WIX_OFFERING>
  | SomeRoute<RoutePath.APP_PAGE>;

export { Route, RoutePath };
